var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DynamicTable',{ref:"data_table",attrs:{"id_tabla":2},on:{"new":function($event){return _vm.nuevo()},"edit":function($event){return _vm.editar($event)},"delete":function($event){return _vm.eliminar($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }